// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"fa656777","303":"fa656777","436":"fa656777"}[chunkId] + ".chunk.css";
};